export default {
  // 非空
  noNull(val) {
    if (!val && val !== 0) {
      return '-'
    } else {
      return val
    }
  },
  NumberToBoolean(num) {
    return +num === 1
  }
}
